<section class="recurso-contextual" *ngIf="recurso" aria-label="Sugestão de recurso">
  <div class="recurso-contextual__icone" aria-hidden="true">
    <i class="fas" [ngClass]="icone"></i>
  </div>
  <div class="recurso-contextual__conteudo">
    <h2>{{titulo}}</h2>
    <p>{{descricao}}</p>
  </div>
  <button type="button" class="btn recurso-contextual__acao" (click)="abraDetalhes()">
    {{interesseAberto ? 'Ver interesse' : 'Conhecer recurso'}}
    <i class="fas fa-arrow-right ml-1" aria-hidden="true"></i>
  </button>
</section>
